import { render, staticRenderFns } from "./newTemplateModal.vue?vue&type=template&id=3e536a26&scoped=true"
import script from "./newTemplateModal.vue?vue&type=script&lang=js"
export * from "./newTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./newTemplateModal.vue?vue&type=style&index=0&id=3e536a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e536a26",
  null
  
)

export default component.exports